// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__jvsSb","title":"FrontImage_title__3zOvF"};